import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { DELETE_SPACE } from './actionTypes'

export const deleteSpace = (spaceId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}`,
        DELETE_SPACE,
        { method: 'DELETE', body: { id: spaceId } },
        { args: { organizationId: ':organizationId', spaceId: spaceId } }
      )
    )
  }
}
